module.exports = __webpack_public_path__ + "img/22-juin-don-organes.eb556afd.jpg";